module.exports = "/_next/static/images/171bb84ea9f6521115cfc7cc3eb546eb-man-looking-up-smiling-md@1x.jpg.webp";